// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"161":"0e17d883fd2a1637","719":"1eebc224847fb794"}[chunkId] + ".js";
};